import { render, staticRenderFns } from "./exhibition-register.vue?vue&type=template&id=ab924208&scoped=true&"
import script from "./exhibition-register.vue?vue&type=script&lang=js&"
export * from "./exhibition-register.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-register.vue?vue&type=style&index=0&id=ab924208&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab924208",
  null
  
)

export default component.exports